import _ from "lodash";
import { Module } from "vuex";
import { CurrentAuditState } from "./types";
import { RootState } from "../../types";

import { getters, getterNames } from "./getters";
import { actions, actionNames } from "./actions";
import { mutations, mutationNames } from "./mutations";

const state = new CurrentAuditState();

const namespaced: boolean = true;
const modul: Module<CurrentAuditState, RootState> = {
  namespaced,
  getters,
  actions,
  mutations,
  state,
};

export const api = {
  namespace: "audit",
  mutations: mutationNames,
  getters: getterNames,
  actions: actionNames,
};
export default modul;
